/**
 * @module TransactionsConstants
 * @requires keyMirror
 */

import keyMirror from 'keymirror';

/**
 * @const TransactionsConstants
 */
export default keyMirror({
  REQUEST_TRANSACTION_LIST_NEW: null,
  REQUEST_TRANSACTION_LIST_SUCCESS_NEW: null,
  REQUEST_TAGS: null,
  REQUEST_TAGS_SUCCESS: null,
  REQUEST_TAG_SELECTED_TRANSACTIONS: null,
  REQUEST_TAG_SELECTED_TRANSACTIONS_SUCCESS: null,
  REQUEST_SEARCH_SUGGESTION: null,
  REQUEST_SEARCH_SUGGESTION_SUCCESS: null,
  REQUEST_ADD_NEW_TAG: null,
  REQUEST_ADD_NEW_TAG_SUCCESS: null,
  REQUEST_SEARCH_TRANSACTIONS: null,
  REQUEST_EDIT_TAG: null,
  REQUEST_DELETE_TAG: null,
  SERVICE_ERROR: null,
  RESET_SEARCH: null,
  RESET_POPUP: null,
  TAGS_SERVICE_ERROR: null,
  TRANSACTION_SERVICE_ERROR: null,
  OTHER_EVENT_ERROR: null,
  REQUEST_TAG_SELECTED_TRANSACTIONS_ERROR: null,
  SET_APPLY_FILTER_STATUS: null,
  REQUEST_TRANSACTIONS_ACCOUNT_POOL: null,
  SORT_SME_TRANSACTIONS: null,
  REQUEST_ENRICHED_DATA: null,
  REQUEST_ENRICHED_DATA_SUCCESS: null,
  ENRICHED_DATA_SERVICE_ERROR: null,
});
